const classNames =
{
    notificationBubble: "notificationBubble",
};

export function updateNumber(notificationContainerId: string, number: number, animate?: boolean)
{
    const notificationContainer = $('#' + notificationContainerId);
    updateBubbleNumber(notificationContainer, getBubble(notificationContainer), number, animate);
}

export function increment(notificationContainerId: string, numberToAdd?: number, animate?: boolean)
{
    const notificationContainer = $('#' + notificationContainerId);

    const bubble = getBubble(notificationContainer);
    if (!bubble)
    {
        return;
    }
    numberToAdd = cleanNumber(numberToAdd);

    const newNumber = getNumberFromBubble(bubble) + numberToAdd;
    updateBubbleNumber(notificationContainer, bubble, newNumber, animate);
}

export function decrement(notificationContainerId: string, numberToSubtract?: number, animate?: boolean)
{
    const notificationContainer = $('#' + notificationContainerId);

    const bubble = getBubble(notificationContainer);
    if (!bubble)
    {
        return;
    }
    numberToSubtract = cleanNumber(numberToSubtract);

    const newNumber = getNumberFromBubble(bubble) - numberToSubtract;
    updateBubbleNumber(notificationContainer, bubble, newNumber, animate);
}

function getBubble(notificationContainer: JQuery<HTMLElement>)
{
    const bubble = notificationContainer.find(`.${classNames.notificationBubble}`);
    return (bubble.length == 0) ? null : bubble;
}

function getNumberFromBubble(bubble: JQuery<HTMLElement>)
{
    const count = bubble.data("count");
    return parseInt(count);
}

function cleanNumber(number?: number)
{
    return (number == undefined || isNaN(number)) ? 1 : number;
}

function updateBubbleNumber(notificationContainer: JQuery<HTMLElement>, bubble: JQuery<HTMLElement> | null, number: number, animate?: boolean)
{
    const displayNumber = (number > 99) ? "99+" : number.toString();

    if (animate == undefined)
    {
        animate = true;
    }

    if (!bubble)
    {
        return;
    }

    if (number == 0)
    {
        bubble.fadeOut(function ()
        {
            bubble.text("");
            setAttributes(notificationContainer, bubble, number);
        });
    }
    else
    {
        if (animate)
        {
            bubble.fadeOut(300, function ()
            {
                bubble.text(displayNumber).fadeIn(300);
                setAttributes(notificationContainer, bubble, number);
            });
        }
        else
        {
            bubble.text(displayNumber);
            setAttributes(notificationContainer, bubble, number);
        }
    }
}

function setAttributes(notificationContainer: JQuery<HTMLElement>, bubble: JQuery<HTMLElement>, number: number)
{
    bubble.data("count", number);
    setAriaLabel(notificationContainer, number);
}

function setAriaLabel(notificationContainer: JQuery<HTMLElement>, number: number)
{
    const ariaLabelSuffix = notificationContainer.data("ariaLabelSuffix") as string | undefined;

    if (ariaLabelSuffix)
    {
        if (number === 0)
        {
            notificationContainer.removeAttr("aria-label");
            return;
        }

        const ariaLabel = (number == 1) ? `1 ${ariaLabelSuffix}` : `${number} ${ariaLabelSuffix}s`;
        notificationContainer.attr("aria-label", ariaLabel);
    }
}